class AccordionImage {
	constructor(accordionImageEl) {
		this.el = accordionImageEl;
		this.imgDiv = this.el.querySelector('.accordion__images');
		if(this.imgDiv != null) {
			this.imgs = this.imgDiv.querySelectorAll('.accordion__image');
		}
		
		this.eventHandlers();
	}

	eventHandlers() {
		if( this.imgDiv ) {
			this.el.querySelectorAll('.accordion-container__header').forEach( (el) => {
				el.addEventListener('click', (e) => {
					e.preventDefault();
					const data = el.getAttribute('data-acc-heading');
					const img = this.el.querySelector(`[data-image="${data}"]`);
					this.imgs.forEach( (i) => {
						i.classList.remove('active');
					});
					img.classList.add('active');
				});
			});
		}
	}
} 

export default AccordionImage;